/**添加自动弹窗逻辑 */
import React, { useState, useEffect } from "react";
import { sysTypeOrEnvType, getSysType, getSysEvnType } from './_config';
import VersionDetails from "./VersionDetails";
import VersionHistory from "./VersionHistory";
import { getNewVersion } from '@/pages/home/services/versionPopup';
import { VersionItemLocaleType, VersionResType, getTranslateVersionInfo } from './_config';
import { getLocale } from 'umi';

interface IVersionAutoPopupProps {
  /**
   * 在接口返回有新版本数据的情况下，是否需要自动弹出新版本公告
   * @param sysEnv 系统环境
   * @param sysType 系统标识，home、情报、gpop
   * @param payload 接口返回新版本公告数据
   * @returns 在接口返回有新版本数据的情况下，是否需要自动弹出新版本公告
   */
  getCanAutoPopup?: (sysEnv: number, sysType: number, payload: Record<string, any>) => boolean;
}

export default function VersionAutoPopup(props: IVersionAutoPopupProps) {
  const { getCanAutoPopup } = props;
  const [visible, setVisible] = useState(false);
  const [versionName, setVersionName] = useState('');
  const [versionInfo, setVersionInfo] = useState<VersionItemLocaleType | null>(null)
  const [activeModule, setActiveModule] = useState(sysTypeOrEnvType.sys_type_dataBrain);
  //系统平台：用于获取自动弹窗接口
  const sysType = getSysType();
  //使用环境：用于发送查询参数
  const sysEnv = getSysEvnType();
  const locale = getLocale();

  useEffect(() => {
    //（首页/情报...）是当前系统,则获取自动弹窗接口
    if (sysType > -1) {
      getIsNewVersion();
    }
  }, [sysType])


  /**获取是否有新版本，有则自动弹窗 */
  const getIsNewVersion = async () => {
    const res: VersionResType = await getNewVersion({
      "sys_env": sysEnv,
      "sys_type": sysType
    })
    try {
      /**返回翻译后的版本数据 */
      const localeVersion = getTranslateVersionInfo(res?.version, locale);
      const _versionName = localeVersion?.version_name;
      if ((res?.version?.sys_type === sysType) && /**返回的版本是当前版本 */
        (typeof _versionName === 'string') && (_versionName.length > 0)) {/**返回的版本有更新 */
        if (
          !getCanAutoPopup ||
          getCanAutoPopup?.(sysEnv, sysType, { ...localeVersion, release_time: res?.version?.release_time })
        ) {
          setVisible(true);
          setVersionName(_versionName);
          setVersionInfo(localeVersion);
          setActiveModule(res?.version?.sys_type);
        }
      }
    } catch (err) {
      setVisible(false);
    }
  }
  if (!visible) {
    return null;
  }
  return (
    <>
      {sysType === sysTypeOrEnvType.sys_type_dataBrain ?
        <VersionHistory
          autoPopup={true} //展示自动弹窗内容
          visible={visible}
          versionName={versionName}
          versionInfo={versionInfo}
        />
        : <VersionDetails
          autoPopup={true} //展示自动弹窗内容
          visible={visible}
          activeModule={activeModule}
          versionName={versionName}
          closeDetails={() => { setVisible(false) }}
        />
      }
    </>
  )
}
